import { render, staticRenderFns } from "./BwMultiselect.vue?vue&type=template&id=e4cd27d0&"
import script from "./BwMultiselect.vue?vue&type=script&lang=js&"
export * from "./BwMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports